import { render, staticRenderFns } from "./RechargePage.vue?vue&type=template&id=56df8c66&scoped=true"
import script from "./RechargePage.vue?vue&type=script&lang=js"
export * from "./RechargePage.vue?vue&type=script&lang=js"
import style0 from "./RechargePage.vue?vue&type=style&index=0&id=56df8c66&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df8c66",
  null
  
)

export default component.exports